import clsx from 'clsx';

export const StatusBoxGradient: React.FC<{ className?: string }> = ({
  className,
}) => (
  <svg
    viewBox="0 0 360 263"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      `absolute -bottom-[120px] -right-[103px] mix-blend-overlay`,
      className,
    )}
  >
    <g className="mix-blend-overlay">
      <path
        d="M529.096 137.838C556.576 251.016 424.379 380.273 233.825 426.541C43.2708 472.808 -133.481 418.566 -160.961 305.387C-188.442 192.208 -56.2443 62.9518 134.31 16.6844C324.864 -29.5831 501.615 24.6592 529.096 137.838Z"
        fill="url(#paint0_radial_760_40463)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_760_40463"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(184.067 221.612) rotate(76.3524) scale(210.882 355.053)"
      >
        <stop stopColor="#0BAEEA" />
        <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);
